import React, { FC, useMemo, useRef, useState } from 'react';

//devextreem
import Form, { Item, RequiredRule } from 'devextreme-react/form';
import { Popup } from 'devextreme-react/popup';
import { DropDownOptions } from 'devextreme-react/select-box';
import ValidationGroup from 'devextreme-react/validation-group';
import Validator from 'devextreme-react/validator';

import { AppGroup, AppRow } from 'components/appComponents';
import AppFiledBox from 'components/appComponents/app-field-box';
import ModalFooter from 'components/appModalFooter';
import { MONEY_FORMAT } from 'constants/formats';
import { NumberBox, SelectBox, TextArea, TextBox } from 'devextreme-react';
import $createDataSource from 'utils/create-data-souce-instance';

import {
  useChangeCashFlowIncomeSellingDetailMutation,
  useCreateCashFlowIncomeSellingDetailMutation,
  useLazyGetCashFlowIncomeSellingDetailQuery,
} from 'bus/cash';
import { CashFlowIncomeSellingDetailItem } from 'bus/cash/types/cashFlowIncomeSelling';

//import { useSelector } from 'react-redux';
//import { RootStore } from 'bus/configureStore';

type CreateEditModalProps = {
  visible: boolean;
  changeVisible: (visible: boolean) => void;
  refresh: () => void;
  id: number | null;
  cashFlowId: number;
};

const initialForm: CashFlowIncomeSellingDetailItem = {
  receivedSum: 0,
  remainderSum: 0,
  requestId: null,
  comment: '',
};

const CreateEditModal: FC<CreateEditModalProps> = ({ changeVisible, refresh, visible, id, cashFlowId }) => {
  let createGroupValidationRef = useRef<ValidationGroup>(null);

  const [form, setForm] = useState<CashFlowIncomeSellingDetailItem>(initialForm);
  const [contragentName, setContragentName] = useState('');

  const [loadCashFlowIncomeSellingDetail] = useLazyGetCashFlowIncomeSellingDetailQuery();
  const [createCashFlowIncomeSellingDetail, { isLoading: isLoadingCreate }] =
    useCreateCashFlowIncomeSellingDetailMutation();
  const [changeCashFlowIncomeSellingDetail, { isLoading: isLoadingChange }] =
    useChangeCashFlowIncomeSellingDetailMutation();

  const disabledSubmit = isLoadingCreate || isLoadingChange;

  const requestStore = useMemo(() => {
    const defaultSort = [{ selector: 'id', desc: true }];
    return $createDataSource('/v1/CashFlowIncomeSelling/requests', 'id', { defaultSort });
  }, []);

  const onShown = async () => {
    if (id) {
      const result = await loadCashFlowIncomeSellingDetail({ cashFlowId, detailId: id });
      setForm(result.data!);
      setContragentName(result.data?.contractor || '');
    } else {
      setForm(initialForm);
    }
  };

  const onHidden = () => {
    setForm(initialForm);
    createGroupValidationRef.current?.instance.reset();
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault && e.preventDefault();

    if (createGroupValidationRef.current?.instance.validate().isValid) {
      if (id) {
        await changeCashFlowIncomeSellingDetail({ ...form, cashFlowId, detailId: id });
      } else {
        await createCashFlowIncomeSellingDetail({ ...form, cashFlowId, detailId: id });
      }
      changeVisible(false);
      refresh();
    }
  };

  return (
    <div>
      <Popup
        visible={visible}
        onHiding={() => changeVisible(false)}
        dragEnabled={true}
        closeOnOutsideClick={false}
        showTitle={true}
        title="Приход от продажи"
        width={500}
        onShowing={onShown}
        onHidden={onHidden}
        height="auto"
      >
        <div className="modal-block">
          <div className="modal-block__content">
            <form onSubmit={handleSubmit}>
              <ValidationGroup ref={createGroupValidationRef}>
                <Form id="test-facrory" formData={form}>
                  <Item colSpan={12} colCount={12} itemType="group">
                    <AppRow>
                      <AppGroup col={12}>
                        <AppFiledBox label="Заявка" labelTop>
                          <SelectBox
                            stylingMode="underlined"
                            dataSource={requestStore}
                            displayExpr="id"
                            valueExpr="id"
                            value={form.requestId}
                            searchEnabled
                            onItemClick={(e) => {
                              setForm((prev) => ({
                                ...prev,
                                requestId: e.itemData.id,
                                remainderSum: e.itemData.requestTotalWithFault,
                              }));
                              setContragentName(e.itemData.contractor);
                            }}
                          >
                            <DropDownOptions title="Выберите заявку" closeOnOutsideClick={true} showTitle={false} />
                            <Validator>
                              <RequiredRule message="Выберите заявку" />
                            </Validator>
                          </SelectBox>
                        </AppFiledBox>

                        <AppFiledBox label="Контрагент" labelTop>
                          <TextBox
                            stylingMode="underlined"
                            placeholder="Контрагент"
                            mode="text"
                            value={contragentName}
                            readOnly
                          />
                        </AppFiledBox>

                        <AppFiledBox label="Сумма по заявке, руб.:" labelTop>
                          <NumberBox
                            stylingMode="underlined"
                            placeholder="0"
                            format={MONEY_FORMAT}
                            value={form.remainderSum}
                            onValueChanged={(e) => {
                              setForm((prev) => ({ ...prev, remainderSum: e.value }));
                            }}
                          >
                            <Validator>
                              <RequiredRule message="Заполните поле Сумма по заявке, руб.:" />
                            </Validator>
                          </NumberBox>
                        </AppFiledBox>

                        <AppFiledBox label="Получено, руб.:" labelTop>
                          <NumberBox
                            stylingMode="underlined"
                            placeholder="0"
                            format={MONEY_FORMAT}
                            value={form.receivedSum}
                            onValueChanged={(e) => {
                              setForm((prev) => ({ ...prev, receivedSum: e.value }));
                            }}
                          >
                            <Validator>
                              <RequiredRule message="Заполните поле Получено, руб.:" />
                            </Validator>
                          </NumberBox>
                        </AppFiledBox>
                        <AppFiledBox label="Комментарий" labelTop>
                          <TextArea
                            stylingMode="underlined"
                            placeholder="Введите комментарий"
                            mode="text"
                            value={form.comment || ''}
                            onChange={(e: any) => {
                              setForm((prev) => ({ ...prev, comment: e.event.currentTarget.value }));
                            }}
                          />
                        </AppFiledBox>
                      </AppGroup>
                    </AppRow>
                  </Item>
                </Form>
                <ModalFooter
                  useSubmitBehavior={false}
                  handleSubmit={handleSubmit}
                  hideModal={() => changeVisible(false)}
                  disabledSubmit={disabledSubmit}
                />
              </ValidationGroup>
            </form>
          </div>
        </div>
      </Popup>
    </div>
  );
};

export default CreateEditModal;
